"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Image = _interopRequireDefault(require("../Image"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("../Button"));

var _Text = _interopRequireDefault(require("../Text"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constant = require("../JourneyPriceCTA/constant");

var _ZeroResult = _interopRequireDefault(require("./ZeroResult.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "ZeroResult__Container",
  componentId: "sc-1sg844j-0"
})(["display:flex;align-items:center;flex-direction:column;"]);

var ImagePadding = _styledComponents.default.div.withConfig({
  displayName: "ZeroResult__ImagePadding",
  componentId: "sc-1sg844j-1"
})(["padding-bottom:120px;height:120px;"]);

var JourneyContainer = _styledComponents.default.div.withConfig({
  displayName: "ZeroResult__JourneyContainer",
  componentId: "sc-1sg844j-2"
})(["display:flex;align-items:center;flex-direction:", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'column' : 'row';
});

var IconRotate = _styledComponents.default.div.withConfig({
  displayName: "ZeroResult__IconRotate",
  componentId: "sc-1sg844j-3"
})(["padding-left:", ";padding-right:", ";transform:rotate(90deg);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
});

var TextPadding = _styledComponents.default.div.withConfig({
  displayName: "ZeroResult__TextPadding",
  componentId: "sc-1sg844j-4"
})(["padding:0% 6% 0% 6%;"]);

var ZeroResult = function ZeroResult(props) {
  var src = props.src,
      imageHeight = props.imageHeight,
      imageWidth = props.imageWidth,
      text = props.text,
      subText = props.subText,
      viewPort = props.viewPort,
      buttonText = props.buttonText,
      isZeroResult = props.isZeroResult,
      emptyStateLoader = props.emptyStateLoader,
      theme = props.theme,
      handleClick = props.handleClick,
      accessible = props.accessible,
      customProperties = props.customProperties,
      showButton = props.showButton,
      fontWeight = props.fontWeight;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var journeyObject = emptyStateLoader;
  var move = theme === _constant.THEMES.MOVE;

  var getTextComponent = function getTextComponent() {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      fontWeight: fontWeight,
      theme: themeContext,
      type: _constant2.COMPONENT_ATTRIBUTES.FONTSIZE_TITLESMALL,
      marginBottom: _constant2.COMPONENT_ATTRIBUTES.MARGIN_BOTTOM_SMALL,
      textAlign: _constant2.COMPONENT_ATTRIBUTES.ALIGN_CENTER,
      customProperties: {
        fontWeight: fontWeight
      }
    }, text);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Container, {
      tabIndex: !accessible ? '-1' : '0',
      customProperties: customProperties
    }, /*#__PURE__*/_react.default.createElement(ImagePadding, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: true,
      centerFocus: true,
      height: imageHeight,
      src: src,
      theme: themeContext,
      width: imageWidth,
      placeHolderBackground: _constant2.COLORS.NONE
    })), viewPort === _constant2.DEVICE_TYPE.mobile ? /*#__PURE__*/_react.default.createElement(TextPadding, null, getTextComponent()) : getTextComponent(), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: false,
      theme: themeContext,
      type: _constant2.COMPONENT_ATTRIBUTES.TEXT_TYPE_SUB,
      marginBottom: _constant2.COMPONENT_ATTRIBUTES.MARGIN_BOTTOM_SMALL,
      textAlign: _constant2.COMPONENT_ATTRIBUTES.ALIGN_CENTER,
      color: _constant2.COLORS.GREY_DARK
    }, subText), !isZeroResult && emptyStateLoader ? /*#__PURE__*/_react.default.createElement(JourneyContainer, {
      isMobile: viewPort === _constant2.DEVICE_TYPE.mobile
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      theme: themeContext,
      type: _constant2.COMPONENT_ATTRIBUTES.TEXT_TYPE_NORMAL
    }, journeyObject.source), /*#__PURE__*/_react.default.createElement(IconRotate, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: _constant2.COLORS.GREY_DARK,
      fontsize: _constant2.COMPONENT_ATTRIBUTES.FONTSIZE_TITLESMALL,
      icon: _constant2.ICONS.FLIGHT_ICON,
      theme: themeContext
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      theme: themeContext,
      type: _constant2.COMPONENT_ATTRIBUTES.TEXT_TYPE_NORMAL
    }, journeyObject.destination)) : (viewPort === _constant2.DEVICE_TYPE.mobile || showButton) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      accessible: true,
      backgroundColor: _constant2.COLORS.PRIMARY,
      boxShadow: true,
      buttonType: _constant2.COMPONENT_ATTRIBUTES.BUTTONTYPE_BUTTON,
      color: move ? _constant2.COLORS.SECONDARY : _constant2.COLORS.DEFAULT,
      border: move ? _constant2.COLORS.SECONDARY : _constant2.COLORS.NONE,
      handleClick: handleClick,
      hoverBackgroundColor: move ? _constant2.COLORS.PRIMARY : _constant2.COLORS.PRIMARY_DARK,
      hoverColor: move ? _constant2.COLORS.SECONDARY : _constant2.COLORS.DEFAULT,
      size: _constant2.COMPONENT_ATTRIBUTES.BUTTONSIZE_NORMAL,
      theme: themeContext
    }, buttonText));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ZeroResult.propTypes = _ZeroResult.default.PropTypes;
ZeroResult.defaultProps = _ZeroResult.default.defaultProps;
var _default = ZeroResult;
exports.default = _default;